import {
  createColumnNumber,
  createColumnText,
  widthOptions,
} from '../../../components/table/function';
import {
  getWarrantyMobileBrandsDisplay,
  getWarrantyMobileModelsDisplay,
} from '../../report-warranty/columns';

const columnMobileBrand = () => ({
  ...createColumnText('ยี่ห้อ', 'mobileBrandName', widthOptions(150)),
  render: (_, record) => getWarrantyMobileBrandsDisplay(record),
});

const columnMobileModel = () => ({
  ...createColumnText('รุ่น', 'mobileModelName', widthOptions(150)),
  render: (_, record) => getWarrantyMobileModelsDisplay(record),
});

export const columns = () => {
  return [
    createColumnText('ชื่อ-นามสกุล', 'userFullName', widthOptions(150)),
    createColumnText('รหัสลงทะเบียน', 'warrantyCode', widthOptions(150)),
    createColumnText('ผู้ทำรายการ', 'logBy', widthOptions(150)),
    createColumnNumber('จำนวนที่เปลี่ยน', 'totalChanges', widthOptions(150)),
    createColumnText('วันที่เปลี่ยน', 'logDate', widthOptions(150)),
  ];
};

export const columnsExpandableBefore = () => {
  return [
    createColumnText('รหัสสินค้า', 'itemCode', widthOptions(150)),
    createColumnText('ชื่อสินค้า', 'productName', widthOptions(150)),
    columnMobileModel(),
    columnMobileBrand(),
  ];
};
export const columnsExpandableAfter = () => {
  return [
    createColumnText('รหัสสินค้า', 'itemCode', widthOptions(150)),
    createColumnText('ชื่อสินค้า', 'productName', widthOptions(150)),
    columnMobileModel(),
    columnMobileBrand(),
    createColumnText('หมายเหตุ', 'remark', widthOptions(150)),
  ];
};
